import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import ImageCounter from '../CreateSidebar/ImageCounter';
import GenerateButton from '../CreateSidebar/GenerateButton';

const GenerateButtonSection = ({ 
    numberOfImages, 
    setNumberOfImages, 
    handleGenerate, 
    loadingCircle 
}) => {
    return (
        <div className="fixed bottom-0 left-0 right-0 lg:right-auto lg:w-1/4 bg-white z-10 p-2 lg:p-3 border-t border-gray-200 shadow-sm">
            <div className="flex items-center gap-3">
                <ImageCounter
                    numberOfImages={numberOfImages}
                    setNumberOfImages={setNumberOfImages}
                />

                <GenerateButton
                    loadingCircle={loadingCircle}
                    handleGenerate={handleGenerate}
                />
            </div>
        </div>
    );
};

export default GenerateButtonSection; 